import Seo from "../components/Seo";

const OPERATOR = {
    name: "Oliver Greune",
    businessName: "Oliver Greune – Beratung | Coaching | Digital",
    street: "Taubenstr. 21",
    zip: "70199",
    city: "Stuttgart",
    country: "Deutschland",
    email: "kontakt@greune.net",
    vatId: "DE319251629",
    leadEmail: "lead@pflegeheim-kosten-fuer-angehoerige.de",
    domain: "pflegeheim-kosten-fuer-angehoerige.de",
};

const LAST_UPDATE = "Februar 2026";

function Section({ title, children }) {
    return (
        <section className="mt-10">
            <h2 className="font-display text-2xl font-bold text-ink-900">{title}</h2>
            <div className="mt-3 space-y-3 text-sm leading-relaxed text-ink-700">{children}</div>
        </section>
    );
}

function SubSection({ title, children }) {
    return (
        <div className="mt-5">
            <h3 className="font-display text-lg font-semibold text-ink-900">{title}</h3>
            <div className="mt-2 space-y-2 text-sm leading-relaxed text-ink-700">{children}</div>
        </div>
    );
}

export function ImpressumPage() {
    return (
        <div className="py-12 sm:py-16">
            <div className="container max-w-3xl">
                <div className="text-xs font-semibold uppercase tracking-wider text-brand-600">Rechtliches</div>
                <h1 className="mt-2 font-display text-4xl font-bold tracking-tight sm:text-5xl">Impressum</h1>
                <p className="mt-3 text-sm text-ink-500">Angaben gemäß § 5 DDG (Digitale-Dienste-Gesetz) / § 5 TMG.</p>

                <Section title="Anbieter">
                    <p>
                        <strong>{OPERATOR.name}</strong><br />
                        {OPERATOR.businessName.replace(OPERATOR.name + " – ", "")}
                    </p>
                    <p>
                        {OPERATOR.street}<br />
                        {OPERATOR.zip} {OPERATOR.city}<br />
                        {OPERATOR.country}
                    </p>
                </Section>

                <Section title="Kontakt">
                    <p>
                        E-Mail:{" "}
                        <a href={`mailto:${OPERATOR.email}`} className="text-brand-700 underline">
                            {OPERATOR.email}
                        </a>
                    </p>
                </Section>

                <Section title="Umsatzsteuer-Identifikationsnummer">
                    <p>
                        Umsatzsteuer-Identifikationsnummer nach § 27a Umsatzsteuergesetz:{" "}
                        <strong>{OPERATOR.vatId}</strong>
                    </p>
                </Section>

                <Section title="Verantwortlich für den Inhalt nach § 18 Abs. 2 MStV">
                    <p>
                        {OPERATOR.name}<br />
                        {OPERATOR.street}, {OPERATOR.zip} {OPERATOR.city}
                    </p>
                </Section>

                <Section title="EU-Streitbeilegung">
                    <p>
                        Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS) bereit:{" "}
                        <a
                            href="https://ec.europa.eu/consumers/odr"
                            target="_blank"
                            rel="noreferrer noopener"
                            className="text-brand-700 underline"
                        >
                            https://ec.europa.eu/consumers/odr
                        </a>
                        .
                    </p>
                    <p>Unsere E-Mail-Adresse finden Sie oben im Impressum.</p>
                </Section>

                <Section title="Verbraucherstreitbeilegung / Universalschlichtungsstelle">
                    <p>
                        Wir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren vor einer
                        Verbraucherschlichtungsstelle teilzunehmen.
                    </p>
                </Section>

                <Section title="Haftung für Inhalte">
                    <p>
                        Als Diensteanbieter sind wir gemäß § 7 Abs. 1 DDG für eigene Inhalte auf diesen Seiten
                        nach den allgemeinen Gesetzen verantwortlich. Nach §§ 8 bis 10 DDG sind wir als
                        Diensteanbieter jedoch nicht verpflichtet, übermittelte oder gespeicherte fremde
                        Informationen zu überwachen oder nach Umständen zu forschen, die auf eine rechtswidrige
                        Tätigkeit hinweisen.
                    </p>
                    <p>
                        Verpflichtungen zur Entfernung oder Sperrung der Nutzung von Informationen nach den
                        allgemeinen Gesetzen bleiben hiervon unberührt. Eine diesbezügliche Haftung ist jedoch
                        erst ab dem Zeitpunkt der Kenntnis einer konkreten Rechtsverletzung möglich. Bei
                        Bekanntwerden von entsprechenden Rechtsverletzungen werden wir diese Inhalte umgehend
                        entfernen.
                    </p>
                </Section>

                <Section title="Haftung für Links">
                    <p>
                        Unser Angebot enthält Links zu externen Websites Dritter, auf deren Inhalte wir keinen
                        Einfluss haben. Deshalb können wir für diese fremden Inhalte auch keine Gewähr
                        übernehmen. Für die Inhalte der verlinkten Seiten ist stets der jeweilige Anbieter
                        oder Betreiber der Seiten verantwortlich. Die verlinkten Seiten wurden zum Zeitpunkt
                        der Verlinkung auf mögliche Rechtsverstöße überprüft. Rechtswidrige Inhalte waren zum
                        Zeitpunkt der Verlinkung nicht erkennbar.
                    </p>
                    <p>
                        Eine permanente inhaltliche Kontrolle der verlinkten Seiten ist jedoch ohne konkrete
                        Anhaltspunkte einer Rechtsverletzung nicht zumutbar. Bei Bekanntwerden von
                        Rechtsverletzungen werden wir derartige Links umgehend entfernen.
                    </p>
                </Section>

                <Section title="Urheberrecht">
                    <p>
                        Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten
                        unterliegen dem deutschen Urheberrecht. Die Vervielfältigung, Bearbeitung,
                        Verbreitung und jede Art der Verwertung außerhalb der Grenzen des Urheberrechtes
                        bedürfen der schriftlichen Zustimmung des jeweiligen Autors bzw. Erstellers.
                    </p>
                    <p>
                        Downloads und Kopien dieser Seite sind nur für den privaten, nicht kommerziellen
                        Gebrauch gestattet. Soweit die Inhalte auf dieser Seite nicht vom Betreiber erstellt
                        wurden, werden die Urheberrechte Dritter beachtet. Insbesondere werden Inhalte
                        Dritter als solche gekennzeichnet.
                    </p>
                </Section>

                <Section title="Wichtiger Hinweis: Keine Rechtsberatung">
                    <p>
                        Die Inhalte dieser Website dienen der Orientierung und Information. Sie stellen
                        ausdrücklich keine Rechts-, Steuer- oder Sozialberatung im Einzelfall dar. Für
                        verbindliche Auskünfte wenden Sie sich bitte an qualifizierte Rechtsanwältinnen
                        und Rechtsanwälte, Steuerberater oder zuständige Behörden.
                    </p>
                </Section>

                <div className="mt-12 rounded-xl bg-amber-50 p-4 text-xs text-amber-900">
                    <strong>Rechtlicher Hinweis:</strong> Dieses Impressum wurde auf Basis der aktuellen
                    Gesetzeslage (Stand: {LAST_UPDATE}) erstellt. Für den produktiven Einsatz wird eine
                    abschließende Prüfung durch eine Rechtsanwältin / einen Rechtsanwalt empfohlen.
                </div>
            </div>
        </div>
    );
}

export function DatenschutzPage() {
    return (
        <div className="py-12 sm:py-16">
            <Seo title="Datenschutzerklärung" description="Informationen gemäß Art. 13 DSGVO: Welche Daten wir verarbeiten, Rechtsgrundlagen, Speicherdauer, Ihre Rechte als betroffene Person." path="/datenschutz" />
            <div className="container max-w-3xl">
                <div className="text-xs font-semibold uppercase tracking-wider text-brand-600">Rechtliches</div>
                <h1 className="mt-2 font-display text-4xl font-bold tracking-tight sm:text-5xl">Datenschutzerklärung</h1>
                <p className="mt-3 text-sm text-ink-500">Stand: {LAST_UPDATE}</p>

                <div className="mt-6 rounded-2xl bg-brand-50/60 p-5 text-sm text-ink-700">
                    Der Schutz Ihrer personenbezogenen Daten hat für uns höchste Priorität. Nachfolgend
                    informieren wir Sie gemäß Art. 13 DSGVO über Art, Umfang und Zweck der
                    Datenverarbeitung auf dieser Website sowie über Ihre Rechte als betroffene Person.
                </div>

                {/* 1 */}
                <Section title="1. Verantwortlicher">
                    <p>
                        Verantwortlicher im Sinne der DSGVO und sonstiger nationaler Datenschutzgesetze ist:
                    </p>
                    <p>
                        {OPERATOR.name}<br />
                        {OPERATOR.businessName.replace(OPERATOR.name + " – ", "")}<br />
                        {OPERATOR.street}<br />
                        {OPERATOR.zip} {OPERATOR.city}<br />
                        E-Mail:{" "}
                        <a href={`mailto:${OPERATOR.email}`} className="text-brand-700 underline">
                            {OPERATOR.email}
                        </a>
                    </p>
                </Section>

                {/* 2 */}
                <Section title="2. Ihre Rechte als betroffene Person">
                    <p>Sie haben uns gegenüber folgende Rechte hinsichtlich der Sie betreffenden personenbezogenen Daten:</p>
                    <ul className="ml-5 list-disc space-y-1">
                        <li>Recht auf Auskunft (Art. 15 DSGVO)</li>
                        <li>Recht auf Berichtigung (Art. 16 DSGVO)</li>
                        <li>Recht auf Löschung (Art. 17 DSGVO)</li>
                        <li>Recht auf Einschränkung der Verarbeitung (Art. 18 DSGVO)</li>
                        <li>Recht auf Widerspruch gegen die Verarbeitung (Art. 21 DSGVO)</li>
                        <li>Recht auf Datenübertragbarkeit (Art. 20 DSGVO)</li>
                        <li>Recht auf Widerruf erteilter Einwilligungen (Art. 7 Abs. 3 DSGVO)</li>
                    </ul>
                    <p>
                        Zudem haben Sie das Recht, sich bei einer Datenschutzaufsichtsbehörde über die
                        Verarbeitung Ihrer personenbezogenen Daten zu beschweren (Art. 77 DSGVO). Zuständig
                        ist die Aufsichtsbehörde Ihres gewöhnlichen Aufenthaltsortes oder die für uns
                        zuständige Behörde: <em>Landesbeauftragter für den Datenschutz Baden-Württemberg</em>.
                    </p>
                </Section>

                {/* 3 */}
                <Section title="3. Erhebung von Zugriffsdaten beim Besuch unserer Website (Server-Logs)">
                    <p>
                        Bei jedem Zugriff auf unsere Website werden automatisch allgemeine Daten erfasst, die
                        Ihr Browser an unseren Server übermittelt (Server-Logfiles):
                    </p>
                    <ul className="ml-5 list-disc space-y-1">
                        <li>IP-Adresse des zugreifenden Rechners (gekürzt/anonymisiert, soweit möglich)</li>
                        <li>Datum und Uhrzeit des Zugriffs</li>
                        <li>Name und URL der abgerufenen Datei</li>
                        <li>Übertragene Datenmenge und Meldung über erfolgreichen Abruf</li>
                        <li>Verwendeter Browser und ggf. Betriebssystem</li>
                        <li>Referrer URL (zuvor besuchte Seite)</li>
                    </ul>
                    <p>
                        <strong>Rechtsgrundlage:</strong> Art. 6 Abs. 1 lit. f DSGVO (berechtigtes Interesse an
                        einer technisch fehlerfreien, sicheren Darstellung).{" "}
                        <strong>Speicherdauer:</strong> i. d. R. 7 Tage, danach gelöscht oder anonymisiert.
                    </p>
                </Section>

                {/* 4 */}
                <Section title="4. Nutzerkonto / Registrierung">
                    <p>
                        Für die Nutzung geschützter Bereiche (Vollergebnis, Konto, Dokumenten-Upload) richten
                        wir ein Nutzerkonto ein. Bei der Registrierung mit E-Mail und Passwort verarbeiten wir:
                    </p>
                    <ul className="ml-5 list-disc space-y-1">
                        <li>E-Mail-Adresse</li>
                        <li>Passwort (ausschließlich als bcrypt-Hash, nie im Klartext)</li>
                        <li>Optional: Name</li>
                        <li>Erstellungszeitpunkt und Einwilligungsstatus</li>
                    </ul>
                    <p>
                        <strong>Rechtsgrundlage:</strong> Art. 6 Abs. 1 lit. b DSGVO (Vertragserfüllung bzw.
                        vorvertragliche Maßnahmen).{" "}
                        <strong>Speicherdauer:</strong> bis zur Löschung Ihres Kontos. Sie können Ihr Konto
                        jederzeit per E-Mail an <a className="text-brand-700 underline" href={`mailto:${OPERATOR.email}`}>{OPERATOR.email}</a> löschen lassen.
                    </p>
                </Section>

                {/* 5 */}
                <Section title="5. Anmeldung mit Google (Single Sign-On)">
                    <p>
                        Optional bieten wir die Anmeldung mit Google über eine datenschutzfreundliche
                        Zwischenintegration von Emergent (Emergent-managed Google Auth) an. Dabei erhalten
                        wir ausschließlich die folgenden, für die Kontoeinrichtung erforderlichen Daten:
                        E-Mail-Adresse, Name und ggf. Profilbild.
                    </p>
                    <p>
                        Weitere Informationen: Google Privacy Policy
                        {" "}
                        (<a className="text-brand-700 underline" href="https://policies.google.com/privacy" target="_blank" rel="noreferrer">policies.google.com/privacy</a>).
                        <br />
                        <strong>Rechtsgrundlage:</strong> Art. 6 Abs. 1 lit. b DSGVO (Vertragserfüllung) sowie
                        Art. 6 Abs. 1 lit. a DSGVO (Einwilligung durch aktive Auswahl des Login-Buttons).
                    </p>
                </Section>

                {/* 6 */}
                <Section title="6. Ersteinschätzungs-Check">
                    <p>
                        Bei der Beantwortung des interaktiven Checks erfassen wir ausschließlich
                        pseudonymisierte Angaben zu Ihrer Situation (Rolle, Pflegegrad, Vermögen, Region
                        etc.) – ohne direkten Personenbezug. Erst nach Login werden diese Angaben mit Ihrem
                        Nutzerkonto verknüpft.
                    </p>
                    <p>
                        <strong>Rechtsgrundlage:</strong> Art. 6 Abs. 1 lit. b DSGVO (Durchführung der
                        angefragten Ersteinschätzung).
                        {" "}
                        <strong>Speicherdauer:</strong> bis zur Kontolöschung oder auf Wunsch früher.
                    </p>
                </Section>

                {/* 7 */}
                <Section title="7. Leadformular / Beratungsanfragen">
                    <p>
                        Wenn Sie eine Beratungsanfrage absenden, verarbeiten wir die von Ihnen angegebenen
                        Daten (Name, E-Mail, Telefon, Rolle, Pflegegrad, Heim-Status, Einkommenslage,
                        gewünschtes Paket, Freitext) zur Bearbeitung Ihrer Anfrage.
                    </p>
                    <p>
                        <strong>Rechtsgrundlage:</strong> Art. 6 Abs. 1 lit. b DSGVO (Durchführung
                        vorvertraglicher Maßnahmen) sowie Art. 6 Abs. 1 lit. a DSGVO (Ihre Einwilligung zur
                        Kontaktaufnahme).
                        {" "}
                        <strong>Speicherdauer:</strong> bis zum Abschluss der Anfrage bzw. maximal 3 Jahre,
                        sofern keine gesetzlichen Aufbewahrungspflichten entgegenstehen.
                    </p>
                </Section>

                {/* 8 */}
                <Section title="8. Dokumenten-Upload und KI-gestützte Voranalyse">
                    <p>
                        Angemeldete Nutzer:innen können Dokumente (z. B. Heimverträge, Bescheide,
                        Pflegegradunterlagen) sicher hochladen. Wir verarbeiten:
                    </p>
                    <ul className="ml-5 list-disc space-y-1">
                        <li>die hochgeladene Datei (PDF, JPG, PNG)</li>
                        <li>den extrahierten Text (bei PDFs)</li>
                        <li>die generierte KI-Zusammenfassung, extrahierte Eckdaten und Relevanzbewertung</li>
                        <li>Metadaten (Dateiname, Größe, Zeitstempel)</li>
                    </ul>
                    <p>
                        Die Textanalyse erfolgt über das Sprachmodell <strong>Claude Sonnet 4.5</strong> der
                        Anthropic PBC (Anbieter: Anthropic PBC, San Francisco, USA) über die integrierte
                        Schnittstelle unseres Infrastrukturpartners Emergent. Es werden ausschließlich der
                        aus dem Dokument extrahierte Text und der Dateiname übermittelt. Die Übermittlung in
                        Drittländer erfolgt auf Grundlage von EU-Standardvertragsklauseln (Art. 46 DSGVO).
                    </p>
                    <p>
                        <strong>Weitergabe an Berater:</strong> Das Originaldokument wird an einen Berater /
                        eine Beraterin ausschließlich dann weitergegeben, wenn Sie es für den jeweiligen
                        Fall <em>explizit und einzeln</em> freigeben. Die KI-Zusammenfassung kann – sofern
                        Sie eine Beratungsanfrage gestellt haben – zur Fallvorbereitung verwendet werden.
                    </p>
                    <p>
                        <strong>Rechtsgrundlage:</strong> Art. 6 Abs. 1 lit. b DSGVO (Vertragserfüllung) und
                        Art. 6 Abs. 1 lit. a DSGVO (Einwilligung durch Upload-Handlung).
                        {" "}
                        <strong>Speicherdauer:</strong> bis zur Löschung durch Sie oder Kontolöschung.
                    </p>
                </Section>

                {/* 9 */}
                <Section title="9. Objekt-Speicher (Hosting der Dokumente)">
                    <p>
                        Hochgeladene Dokumente werden verschlüsselt in einem objektorientierten
                        Cloud-Speicher unseres Infrastrukturpartners Emergent abgelegt. Die Speicherung
                        erfolgt so, dass die Dateien nicht öffentlich abrufbar sind und ausschließlich über
                        unsere Backend-Anwendung nach Authentifizierung bereitgestellt werden.
                    </p>
                </Section>

                {/* 10 */}
                <Section title="10. E-Mail-Versand von Benachrichtigungen (Resend)">
                    <p>
                        Für den Versand transaktionaler E-Mails (z. B. Lead-Benachrichtigungen an unser
                        Team) nutzen wir den Dienst <strong>Resend</strong> der Resend, Inc. (2261 Market
                        Street #4667, San Francisco, CA 94114, USA). Verarbeitet werden hierbei
                        Empfängeradresse, Betreff und Inhalt der Nachricht.
                    </p>
                    <p>
                        <strong>Rechtsgrundlage:</strong> Art. 6 Abs. 1 lit. f DSGVO (berechtigtes Interesse
                        an einer zuverlässigen E-Mail-Zustellung). Datenübermittlungen in die USA erfolgen
                        auf Basis von EU-Standardvertragsklauseln (Art. 46 DSGVO).
                    </p>
                </Section>

                {/* 11 */}
                <Section title="11. Cookies und lokale Speicherung">
                    <p>Wir setzen ausschließlich <strong>technisch notwendige</strong> Cookies ein:</p>
                    <ul className="ml-5 list-disc space-y-1">
                        <li>
                            <code>access_token</code> – httpOnly-Cookie, Authentifizierung bei E-Mail-Login
                            (Laufzeit 7 Tage)
                        </li>
                        <li>
                            <code>session_token</code> – httpOnly-Cookie, Authentifizierung bei Google-Login
                            (Laufzeit 7 Tage)
                        </li>
                    </ul>
                    <p>
                        Zusätzlich nutzen wir den lokalen Speicher Ihres Browsers (localStorage), um den
                        Fortschritt im Check-Assistenten clientseitig zu sichern (Schlüssel:{" "}
                        <code>pflegeheim_check_v1</code>). Diese Daten verlassen Ihr Gerät nicht.
                    </p>
                    <p>
                        <strong>Rechtsgrundlage:</strong> § 25 Abs. 2 Nr. 2 TTDSG (unbedingt erforderliche
                        Speicherung) in Verbindung mit Art. 6 Abs. 1 lit. b DSGVO.
                    </p>
                </Section>

                {/* 12 */}
                <Section title="12. Hosting und Auftragsverarbeitung">
                    <p>
                        Die Website wird bei unserem Infrastrukturpartner <strong>Emergent</strong> gehostet.
                        Zur Erfüllung der datenschutzrechtlichen Anforderungen ist ein Vertrag zur
                        Auftragsverarbeitung gemäß Art. 28 DSGVO abgeschlossen.
                    </p>
                </Section>

                {/* 13 */}
                <Section title="13. Datensicherheit (SSL/TLS)">
                    <p>
                        Diese Website verwendet aus Gründen der Sicherheit und zum Schutz der Übertragung
                        vertraulicher Inhalte (z. B. Anfragen an uns als Seitenbetreiber) eine SSL/TLS-
                        Verschlüsselung. Eine verschlüsselte Verbindung erkennen Sie am Schloss-Symbol in
                        Ihrer Browserzeile und daran, dass die Adresse mit <code>https://</code> beginnt.
                    </p>
                </Section>

                {/* 14 */}
                <Section title="14. Speicherdauer">
                    <p>
                        Personenbezogene Daten werden so lange gespeichert, wie es für den jeweiligen Zweck
                        erforderlich ist oder gesetzliche Aufbewahrungsfristen bestehen (z. B. aus Handels-
                        oder Steuerrecht). Nach Wegfall des Zwecks werden die Daten gelöscht oder
                        anonymisiert.
                    </p>
                </Section>

                {/* 15 */}
                <Section title="15. Widerruf, Löschung und Kontakt">
                    <p>
                        Sie können Ihre Einwilligung jederzeit mit Wirkung für die Zukunft widerrufen und die
                        Löschung Ihrer Daten verlangen. Bitte senden Sie eine formlose E-Mail an{" "}
                        <a className="text-brand-700 underline" href={`mailto:${OPERATOR.email}`}>{OPERATOR.email}</a>.
                    </p>
                </Section>

                {/* 16 */}
                <Section title="16. Änderungen dieser Datenschutzerklärung">
                    <p>
                        Wir behalten uns vor, diese Datenschutzerklärung anzupassen, damit sie stets den
                        aktuellen rechtlichen Anforderungen entspricht oder um Änderungen unserer Leistungen
                        umzusetzen. Für Ihren erneuten Besuch gilt dann die aktuelle
                        Datenschutzerklärung.
                    </p>
                </Section>

                <Section title="17. Automatisierte Entscheidungsfindung / Profiling">
                    <p>
                        Eine automatisierte Entscheidungsfindung einschließlich Profiling nach Art. 22 DSGVO
                        findet nicht statt. Die KI-gestützte Voranalyse hochgeladener Dokumente dient
                        ausschließlich der inhaltlichen Vorbereitung einer persönlichen Beratung und hat
                        keine rechtliche oder ähnlich erhebliche Wirkung für Sie.
                    </p>
                </Section>

                <SubSection title="Keine Rechtsberatung">
                    <p>
                        Die Inhalte dieser Website – einschließlich der automatisierten Einschätzung und
                        der KI-Voranalyse – dienen der Orientierung. Sie stellen <strong>keine</strong>{" "}
                        Rechts-, Steuer- oder Sozialberatung im Einzelfall dar. Für verbindliche Auskünfte
                        wenden Sie sich bitte an qualifizierte Berufsträger oder zuständige Behörden.
                    </p>
                </SubSection>

                <div className="mt-12 rounded-xl bg-amber-50 p-4 text-xs text-amber-900">
                    <strong>Rechtlicher Hinweis:</strong> Diese Datenschutzerklärung wurde auf Basis der
                    aktuellen Gesetzeslage (Stand: {LAST_UPDATE}) sorgfältig zusammengestellt. Für den
                    produktiven Einsatz wird eine abschließende Prüfung durch eine Rechtsanwältin / einen
                    Rechtsanwalt bzw. einen externen Datenschutzbeauftragten empfohlen.
                </div>
            </div>
        </div>
    );
}
